import { render, staticRenderFns } from "./Nuevo_aliado.vue?vue&type=template&id=28fc579e&"
import script from "./Nuevo_aliado.vue?vue&type=script&lang=js&"
export * from "./Nuevo_aliado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports